import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { useSsoUrl } from "@common/hooks/useSsoUrl";
import { ISsoProfile } from "../contracts";

export interface UserProfilesFilter {
  profileRole?: string;
}

export interface UseUserProfilesOptions {
  filter?: UserProfilesFilter;
}

export function useUserProfiles(options: UseUserProfilesOptions | undefined = {}) {
  const { request } = useSsoUrl();
  return useQuery("userProfiles" + JSON.stringify(options), async () => {
    const { userProfiles } = await request(
      gql`
        query userProfiles($filter: UserProfilesFilter) {
          userProfiles(filter: $filter) {
            description
            type
          }
        }
      `,
      options
    );

    const orderedRoles = userProfiles.sort((current : ISsoProfile, next: ISsoProfile) => (
      current.description > next.description) ? 1 : 
      ((next.description > current.description) ? -1 : 0)
    )
    return orderedRoles;
  });
}
